"use strict";

_BannerFlowApp.directive("itemIcon", function () {
    return {
        restrict: "E", // element
        templateUrl: "/legacy-app/js/directives/templates/item-icon.html",
        replace: true,
        scope: {
            objectType: "=",
            objectInstance: "="
        },
        controller: function ($scope, $attrs) {},
        link: function (scope, element, attrs, modelCtrl) {}
    };
});
